import React from "react"
import PropTypes from "prop-types"
import Button from "../../button/Button"
import { Container } from "../../forms/button-group/styles"
import { StyledCSVLink } from "./styles"
import ButtonSelect from "../../button-select"

const Actions = ({ actions, actionHandler, csvData }) => {
  const actionButtons = actions.filter((a) => a.type === "button")
  const actionOptions = actions.filter((a) => a.type === "option")

  const handleClick = ({ param, type }) => {
    if (actionHandler !== undefined) actionHandler(param, type)
  }

  const handleActionOption = (event, option) => {
    event.preventDefault()
    const opt = actionOptions.find((o) => o.name === option)
    if (opt) handleClick(opt)
  }

  return (
    <>
      {actions.length > 0 && (
        <Container>
          {actionButtons.map((action) => {
            if (action.param === "export")
              return (
                <StyledCSVLink filename="export.csv" target="_blank" data={csvData} size="small" variant="secondary">
                  {action.name}
                </StyledCSVLink>
              )
            else
              return (
                <Button onClick={() => handleClick(action)} size="small" variant="secondary">
                  {action.name}
                </Button>
              )
          })}
          {actionOptions.length > 0 && (
            <ButtonSelect
              size="small"
              title="Actions"
              options={actionOptions.map((a) => a.name)}
              clickHandler={handleActionOption}
            />
          )}
        </Container>
      )}
    </>
  )
}

Actions.propTypes = {
  actions: PropTypes.array,
  actionHandler: PropTypes.func,
  csvData: PropTypes.array
}

Actions.defaultProps = {
  actions: [],
  actionHandler: undefined,
  csvData: []
}

export default Actions
